import * as React from "react";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import "./button-toggle.scss";

export const ButtonToggle = ({ value, content, ...props }) => {
  return (
    <Stack direction="row" spacing={4} className={props.stackclass || ""}>
      <ToggleButtonGroup
        value={value}
        exclusive
        {...props}
        className={`button-toggle ${props.customClass}`}
      >
        {content.length > 0 &&
          content.map((item, index) => {
            return (
              <ToggleButton
                key={index}
                value={item.value}
                aria-label={item.value}
              >
                {item.children}
              </ToggleButton>
            );
          })}
      </ToggleButtonGroup>
    </Stack>
  );
};
